module.exports = __webpack_public_path__ + "next2.3decb707.png";